
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcKeyboardFull as ObcKeyboardFullElement} from '@oicl/openbridge-webcomponents/dist/components/keyboard-full/keyboard-full.js';
 
 
 

 
 export const ObcKeyboardFull = createComponent({
   react: React,
   tagName: 'obc-keyboard-full',
   elementClass: ObcKeyboardFullElement,
   events: {
     
     onValueChange: 'value-change' as EventName<CustomEvent<{value: string}>>,
     onDoneClick: 'done-click' as EventName<CustomEvent<{value: string}>>,
     onCloseClick: 'close-click' as EventName<CustomEvent<void>>,
   }
  });
 
 